import React, { useEffect, useState } from "react"
import styles from "./modalInbox.module.css"
import Modal from '../index'
import BreakForm from '../../Form/BreakForm/index'
import Button from "../../Form/Button"
import FormGroup from "../../Form/FormGroup"
import FormGroupInline from '../../Form/FormGroupInline'
import Input from '../../Form/Input'
import Textarea from '../../Form/Textarea'
import Select from '../../Form/Select'
import { FaPencilAlt } from "react-icons/fa"
import { MdOutlineDelete, MdOutlineWhatsapp } from "react-icons/md"
import { RiInstagramLine, RiMessengerLine } from "react-icons/ri"
import { HiPlus } from "react-icons/hi"
import { getOptionByOptionList, getPropertyForItemInArrayById, getUsersBySelectedTeams, getValidUserIdsByTeams } from "../../../utils/utils"
import { listAssignTo } from "../../../schemas/Chat"
import TimePicker from "../../Form/TimePicker"
import { getStages } from "../../../schemas/Stage"

const signOptions = [
    { id: "fullName", value: "Nome Completo" },
    { id: "firstName", value: "Primeiro Nome" },
]
const optionsBoolean = [
    { id: 1, value: "Sim" },
    { id: 0, value: "Não" },
]
const chatBotOptions = [
    { id: "okttoBotAI", value: "Oktto AI" },
    { id: "okttoBotAIFlow", value: "Oktto AI Flow" },
    { id: "okttoAgent", value: "Oktto AI Agent" },
    { id: "zaia", value: "Zaia" },
]
const contactExistsOptions = [
    { id: "addToOwnerLead", value: "Atribuir aos responsáveis pelo lead" },
    { id: "default", value: "Seguir atribuição padrão" },
]
const finishedConversationOptions = [
    { id: "resetOwner", value: "Redefinir responsáveis" },
    { id: "keepAsIs", value: "Manter como está" },
]
const roundRobinModeOptions = [
    { id: "roles", value: "Padrão pelos cargos com rodízio ativo" },
    { id: "custom", value: "Usuários específicos para esta caixa" },
]
const leadAssignmentSourceOptions = [
    { id: "conversationOwner", value: "Usar responsáveis da conversa" },
    { id: "custom", value: "Usar regra própria" },
]
const weekDaysOptions = [
    { id: 0, value: "Domingo" },
    { id: 1, value: "Segunda" },
    { id: 2, value: "Terça" },
    { id: 3, value: "Quarta" },
    { id: 4, value: "Quinta" },
    { id: 5, value: "Sexta" },
    { id: 6, value: "Sábado" },
]

const ModalInbox = ({ inbox = {}, teams = [], users = [], usersWithAuto = [], roles = [], chatBots = [], funnels = [], onSubmit = () => { }, closeModal = () => { } }) => {
    const [leadStages, setLeadStages] = useState([])
    const [newInbox, setNewInbox] = useState({
        ...inbox,
        leadAssignmentSource: inbox?.leadAssignmentSource || (inbox?.assignNewConversation === "users" ? "conversationOwner" : "custom"),
        settings: {
            ...inbox?.settings,
            automations: {
                welcome: {
                    enabled: false,
                    message: ""
                },
                schedule: {
                    enabled: false,
                    periods: [{
                        days: [],
                        start: "09:00",
                        end: "18:00",
                        message: "",
                        cooldown_minutes: 30
                    }]
                },
                inactive_open: {
                    enabled: false,
                    message: "",
                    delay_minutes: 120
                },
                reopen: {
                    enabled: false,
                    message: ""
                },
                ...inbox?.settings?.automations
            }
        }
    })
    const [editable, setEditable] = useState(false)

    useEffect(() => {
        if (!newInbox?.leadFunnelId) {
            setLeadStages([])
            return
        }

        getStages(newInbox.leadFunnelId).then(stages => {
            setLeadStages(stages?.map(stage => ({ id: stage._id, value: stage.name })) || [])
        })
    }, [newInbox?.leadFunnelId])

    const handleChangeValue = (name, value) => {
        setNewInbox(previousValue => {
            if (name === "teams") {
                const inboxTeams = Array.isArray(value) ? value : []
                const filteredUsers = getValidUserIdsByTeams(previousValue.users, inboxTeams, users, teams, [], previousValue.teams)
                const teamUserIds = getUsersBySelectedTeams(inboxTeams, users, teams).map(user => user.id)
                const allowedUsers = new Set(filteredUsers.length ? filteredUsers : teamUserIds)
                return {
                    ...previousValue,
                    teams: value,
                    users: filteredUsers,
                    usersOwner: (previousValue.usersOwner || []).filter(user => user === "auto" || allowedUsers.has(user)),
                    roundRobinUsers: (previousValue.roundRobinUsers || []).filter(user => allowedUsers.has(user)),
                    leadUsers: (previousValue.leadUsers || []).filter(user => user === "auto" || allowedUsers.has(user)),
                    leadRoundRobinUsers: (previousValue.leadRoundRobinUsers || []).filter(user => allowedUsers.has(user)),
                    team_id: inboxTeams.length && !inboxTeams.includes(previousValue.team_id) ? "" : previousValue.team_id
                }
            }

            if (name === "users") {
                const inboxUsers = Array.isArray(value) ? value : []
                const filterAllowedUsers = (selectedUsers = []) => {
                    if (!inboxUsers.length) return selectedUsers
                    return selectedUsers.filter(user => user === "auto" || inboxUsers.includes(user))
                }

                return {
                    ...previousValue,
                    users: value,
                    usersOwner: filterAllowedUsers(previousValue.usersOwner || []),
                    roundRobinUsers: filterAllowedUsers(previousValue.roundRobinUsers || []).filter(user => user !== "auto"),
                    leadUsers: filterAllowedUsers(previousValue.leadUsers || []),
                    leadRoundRobinUsers: filterAllowedUsers(previousValue.leadRoundRobinUsers || []).filter(user => user !== "auto")
                }
            }

            if (name === "assignNewConversation") {
                return {
                    ...previousValue,
                    assignNewConversation: value,
                    leadAssignmentSource: value === "users" ? "conversationOwner" : "custom"
                }
            }

            return { ...previousValue, [name]: value }
        })
    }

    const handleChangeUsersOwner = (value) => {
        setNewInbox(previousValue => ({
            ...previousValue,
            usersOwner: value,
            ...(!value?.includes("auto") ? { roundRobinMode: "roles", roundRobinUsers: [] } : {})
        }))
    }

    const handleChangeLeadUsers = (value) => {
        setNewInbox(previousValue => ({
            ...previousValue,
            leadUsers: value,
            ...(!value?.includes("auto") ? { leadRoundRobinMode: "roles", leadRoundRobinUsers: [] } : {})
        }))
    }

    const handleChangeLeadFunnel = (value) => {
        setNewInbox(previousValue => ({
            ...previousValue,
            leadFunnelId: value,
            leadStageId: "",
            leadTeamId: "",
            leadUsers: [],
            leadRoundRobinMode: "roles",
            leadRoundRobinUsers: []
        }))
    }

    const handleChangeLeadTeam = (value) => {
        setNewInbox(previousValue => ({
            ...previousValue,
            leadTeamId: value,
            leadUsers: [],
            leadRoundRobinMode: "roles",
            leadRoundRobinUsers: []
        }))
    }

    const handleSettingsChange = (name, value) => {
        setNewInbox(previousValue => { return { ...previousValue, settings: { ...previousValue.settings, [name]: value } } })
    }

    const handleAutomationChange = (path, value) => {
        setNewInbox(prev => {
            const updated = structuredClone(prev)

            const keys = path.split(".")
            let current = updated.settings.automations

            for (let i = 0; i < keys.length - 1; i++) {
                const key = keys[i]
                current = current[key]
            }

            current[keys[keys.length - 1]] = value

            return updated
        })
    }

    const handleAddPeriod = () => {
        setNewInbox(prev => ({
            ...prev,
            settings: {
                ...prev.settings,
                automations: {
                    ...prev.settings.automations,
                    schedule: {
                        ...prev.settings.automations.schedule,
                        periods: [
                            ...(prev.settings.automations.schedule.periods || []),
                            {
                                days: [],
                                start: "09:00",
                                end: "18:00",
                                message: "",
                                cooldown_minutes: 30
                            }
                        ]
                    }
                }
            }
        }))
    }

    const handleRemovePeriod = (index) => {
        setNewInbox(prev => {
            const periods = [...prev.settings.automations.schedule.periods]
            periods.splice(index, 1)
            return {
                ...prev,
                settings: {
                    ...prev.settings,
                    automations: {
                        ...prev.settings.automations,
                        schedule: {
                            ...prev.settings.automations.schedule,
                            periods
                        }
                    }
                }
            }
        })
    }

    const handleCancel = (e) => {
        e.preventDefault()
        setEditable(false)
        setNewInbox({
            ...inbox,
            settings: {
                ...inbox?.settings,
                automations: {
                    welcome: {
                        enabled: false,
                        message: ""
                    },
                    schedule: {
                        enabled: false,
                        periods: [{
                            days: [],
                            start: "09:00",
                            end: "18:00",
                            message: "",
                            cooldown_minutes: 30
                        }]
                    },
                    inactive_open: {
                        enabled: false,
                        message: "",
                        delay_minutes: 120
                    },
                    reopen: {
                        enabled: false,
                        message: ""
                    },
                    ...inbox?.settings?.automations
                }
            }
        })
    }

    const handleSave = (e) => {
        e.preventDefault()
        onSubmit(newInbox)
    }

    const getRoundRobinUserOptions = () => {
        if (newInbox?.users?.length) {
            return users.filter(user => newInbox.users.includes(user.id))
        }

        return users
    }

    const getUsersOwnerOptions = () => {
        const availableUsers = newInbox?.users?.length ? users.filter(user => newInbox.users.includes(user.id)) : users
        return [{ id: "auto", value: "Rodízio Automático" }, ...availableUsers]
    }

    const getTeamOwnerOptions = () => {
        return newInbox?.teams?.length ? teams.filter(team => newInbox.teams.includes(team.id)) : teams
    }

    const getLeadTeamOptions = () => {
        const funnel = funnels?.find(funnel => funnel.id === newInbox?.leadFunnelId)
        if (!funnel?.teams?.length) return teams
        const funnelTeams = funnel.teams.map(team => team?.toString())
        return teams.filter(team => funnelTeams.includes(team.id?.toString()))
    }

    const getLeadUserOptions = () => {
        const availableUsers = !newInbox?.leadTeamId ? users : users.filter(user => {
            if (!user?.teams?.length) return true
            return user.teams.map(team => team?.toString()).includes(newInbox.leadTeamId?.toString())
        })
        return [{ id: "auto", value: "Rodízio Automático" }, ...availableUsers]
    }

    const getLeadRoundRobinUserOptions = () => {
        return getLeadUserOptions().filter(user => user.id !== "auto")
    }

    const getInboxPlatformLabel = () => {
        if (inbox?.platform === "messenger") return "Messenger"
        if (inbox?.platform === "direct") return "Instagram Direct"
        return "WhatsApp"
    }

    const getInboxPlatformIcon = () => {
        if (inbox?.platform === "messenger") return <RiMessengerLine style={{ color: "#0084ff" }} />
        if (inbox?.platform === "direct") return <RiInstagramLine style={{ color: "#e4405f" }} />
        return <MdOutlineWhatsapp style={{ color: "#25d366" }} />
    }

    return (
        <Modal
            icon={getInboxPlatformIcon()}
            title={`Caixa de entrada do ${getInboxPlatformLabel()}`}
            description={"Configure sua caixa de entrada"}
            closeModal={closeModal}
        >
            <form onSubmit={(e) => e?.preventDefault()}>
                <BreakForm title="Informações básicas" showAction={false} border={false} />
                <FormGroupInline>
                    <FormGroup labelText="Nome">
                        {editable ?
                            <Input type="text" placeholder="Nome da caixa de entrada" value={newInbox?.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} />
                            :
                            <span>{newInbox.name ?? "-"}</span>
                        }
                    </FormGroup>
                    {!editable &&
                        <Button variant="secondary" className={`${styles.editButton} action`} onClick={() => setEditable(true)}>
                            <FaPencilAlt />
                        </Button>
                    }
                </FormGroupInline>
                <FormGroup labelText="Equipes">
                    {editable ?
                        <Select name="Equipes" placeholder="Pesquise uma opção" options={teams || []} selected={newInbox?.teams ?? ""} onChange={(value) => handleChangeValue("teams", value)} multiple={true} />
                        :
                        <span>{getOptionByOptionList(newInbox.teams, teams, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Usuários">
                    {editable ?
                        <Select name="Usuários" placeholder="Pesquise uma opção" options={getUsersBySelectedTeams(newInbox?.teams, users, teams)} selected={newInbox?.users ?? ""} onChange={(value) => handleChangeValue("users", value)} multiple={true} />
                        :
                        <span>{getOptionByOptionList(newInbox.users, users, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                {inbox?.platform === "whatsapp" &&
                    <FormGroup labelText="Ignorar Grupos">
                        {editable ?
                            <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={optionsBoolean || []} selected={+newInbox?.settings?.groups_ignore ?? ""} onChange={(value) => handleSettingsChange("groups_ignore", value)} multiple={false} />
                            :
                            <span>{getPropertyForItemInArrayById(+newInbox?.settings?.groups_ignore, optionsBoolean, "id", "value") || "-"}</span>
                        }
                    </FormGroup>
                }

                <BreakForm title="Chatbot" showAction={false} />
                <FormGroup labelText="Ativar">
                    {editable ?
                        <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={optionsBoolean || []} selected={+newInbox?.is_active_bot ?? ""} onChange={(value) => handleChangeValue("is_active_bot", value)} multiple={false} />
                        :
                        <span>{getPropertyForItemInArrayById(+newInbox.is_active_bot, optionsBoolean, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                {Boolean(+newInbox.is_active_bot) &&
                    <>
                        <FormGroup labelText="Tipo">
                            {editable ?
                                <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={chatBotOptions || []} selected={newInbox?.integration ?? ""} onChange={(value) => handleChangeValue("integration", value)} multiple={false} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox.integration, chatBotOptions, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                        <FormGroup labelText="Modelo">
                            {editable ?
                                <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={chatBots?.filter(chatbot => chatbot?.is_active && chatbot?.type === newInbox?.integration)?.map(chatbot => ({ id: chatbot._id, value: chatbot?.name })) || []} selected={newInbox?.chat_bot_id ?? ""} onChange={(value) => handleChangeValue("chat_bot_id", value)} multiple={false} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox.chat_bot_id, chatBots, "_id", "name") || "-"}</span>
                            }
                        </FormGroup>
                    </>
                }

                <BreakForm title="Conversas" showAction={false} />
                <FormGroup labelText="Atribuição de novas conversas">
                    {editable ?
                        <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={listAssignTo || []} selected={newInbox?.assignNewConversation ?? ""} onChange={(value) => handleChangeValue("assignNewConversation", value)} multiple={false} />
                        :
                        <span>{getPropertyForItemInArrayById(newInbox.assignNewConversation, listAssignTo, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                {newInbox?.assignNewConversation === "teamAndRole" &&
                    <>
                        <FormGroup labelText="Equipe">
                            {editable ?
                                <Select name="Selecione uma opção..." placeholder="Pesquisar..." options={getTeamOwnerOptions()} selected={newInbox?.team_id ?? ""} multiple={false} onChange={(value) => handleChangeValue("team_id", value)} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox.team_id, teams, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                        <FormGroup labelText="Cargo">
                            {editable ?
                                <Select name="Selecione uma opção..." placeholder="Pesquisar..." options={roles} selected={newInbox?.role_id ?? ""} multiple={false} onChange={(value) => handleChangeValue("role_id", value)} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox.role_id, roles, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                    </>
                }
                {newInbox?.assignNewConversation === "users" &&
                    <>
                        <FormGroup labelText="Usuários">
                            {editable ?
                                <Select name="Usuários" placeholder="Pesquisar..." options={getUsersOwnerOptions()} selected={newInbox?.usersOwner ?? []} multiple={true} onChange={handleChangeUsersOwner} />
                                :
                                <span>{getOptionByOptionList(newInbox.usersOwner, usersWithAuto, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                        {newInbox?.usersOwner?.includes("auto") &&
                            <>
                                <FormGroup labelText="Base do rodízio automático">
                                    {editable ?
                                        <Select name="Base do rodízio" placeholder="Pesquisar..." options={roundRobinModeOptions} selected={newInbox?.roundRobinMode || "roles"} multiple={false} onChange={(value) => handleChangeValue("roundRobinMode", value)} />
                                        :
                                        <span>{getPropertyForItemInArrayById(newInbox?.roundRobinMode || "roles", roundRobinModeOptions, "id", "value") || "-"}</span>
                                    }
                                </FormGroup>
                                {(newInbox?.roundRobinMode === "custom") &&
                                    <FormGroup labelText="Usuários do rodízio personalizado">
                                        {editable ?
                                            <Select name="Usuários do rodízio" placeholder="Pesquisar..." options={getRoundRobinUserOptions()} selected={newInbox?.roundRobinUsers || []} multiple={true} onChange={(value) => handleChangeValue("roundRobinUsers", value)} />
                                            :
                                            <span>{getOptionByOptionList(newInbox.roundRobinUsers, users, "id", "value") || "-"}</span>
                                        }
                                    </FormGroup>
                                }
                            </>
                        }
                    </>
                }
                <FormGroup labelText="Contato existente em lead">
                    {editable ?
                        <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={contactExistsOptions || []} selected={newInbox?.leadContactExists ?? ""} onChange={(value) => handleChangeValue("leadContactExists", value)} multiple={false} />
                        :
                        <span>{getPropertyForItemInArrayById(newInbox.leadContactExists, contactExistsOptions, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Conversa finalizada">
                    {editable ?
                        <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={finishedConversationOptions || []} selected={newInbox?.finishedConversation ?? ""} onChange={(value) => handleChangeValue("finishedConversation", value)} multiple={false} />
                        :
                        <span>{getPropertyForItemInArrayById(newInbox.finishedConversation, finishedConversationOptions, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                <BreakForm title="Leads" showAction={false} />
                <FormGroup labelText="Criar lead automaticamente">
                    {editable ?
                        <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={optionsBoolean || []} selected={+newInbox?.createNewLead ?? ""} onChange={(value) => handleChangeValue("createNewLead", value)} multiple={false} />
                        :
                        <span>{getPropertyForItemInArrayById(+newInbox.createNewLead, optionsBoolean, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                {Boolean(+newInbox?.createNewLead) &&
                    <>
                        <FormGroup labelText="Funil">
                            {editable ?
                                <Select name="Funil" placeholder="Pesquise um funil" options={funnels || []} selected={newInbox?.leadFunnelId ?? ""} onChange={handleChangeLeadFunnel} multiple={false} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox.leadFunnelId, funnels, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                        <FormGroup labelText="Etapa">
                            {editable ?
                                <Select name="Etapa" placeholder="Pesquise uma etapa" options={leadStages || []} selected={newInbox?.leadStageId ?? ""} onChange={(value) => handleChangeValue("leadStageId", value)} multiple={false} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox.leadStageId, leadStages, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                        <FormGroup labelText="Equipe">
                            {editable ?
                                <Select name="Equipe" placeholder="Pesquise uma equipe" options={getLeadTeamOptions()} selected={newInbox?.leadTeamId ?? ""} onChange={handleChangeLeadTeam} multiple={false} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox.leadTeamId, teams, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                        <FormGroup labelText="Responsáveis do lead">
                            {editable ?
                                <Select name="Regra de responsáveis" placeholder="Selecione uma regra" options={newInbox?.assignNewConversation === "users" ? leadAssignmentSourceOptions : leadAssignmentSourceOptions.filter(option => option.id === "custom")} selected={newInbox?.leadAssignmentSource || "conversationOwner"} onChange={(value) => handleChangeValue("leadAssignmentSource", value)} multiple={false} />
                                :
                                <span>{getPropertyForItemInArrayById(newInbox?.leadAssignmentSource || (newInbox?.assignNewConversation === "users" ? "conversationOwner" : "custom"), leadAssignmentSourceOptions, "id", "value") || "-"}</span>
                            }
                        </FormGroup>
                        {newInbox?.leadAssignmentSource === "custom" &&
                            <FormGroup labelText="Responsáveis">
                                {editable ?
                                    <Select name="Responsáveis" placeholder="Pesquise usuários" options={getLeadUserOptions()} selected={newInbox?.leadUsers ?? []} onChange={handleChangeLeadUsers} multiple={true} />
                                    :
                                    <span>{getOptionByOptionList(newInbox.leadUsers, [{ id: "auto", value: "Rodízio Automático" }, ...users], "id", "value") || "-"}</span>
                                }
                            </FormGroup>
                        }
                        {newInbox?.leadAssignmentSource === "custom" && newInbox?.leadUsers?.includes("auto") &&
                            <>
                                <FormGroup labelText="Base do rodízio automático">
                                    {editable ?
                                        <Select name="Base do rodízio" placeholder="Pesquisar..." options={roundRobinModeOptions} selected={newInbox?.leadRoundRobinMode || "roles"} multiple={false} onChange={(value) => handleChangeValue("leadRoundRobinMode", value)} />
                                        :
                                        <span>{getPropertyForItemInArrayById(newInbox?.leadRoundRobinMode || "roles", roundRobinModeOptions, "id", "value") || "-"}</span>
                                    }
                                </FormGroup>
                                {(newInbox?.leadRoundRobinMode === "custom") &&
                                    <FormGroup labelText="Usuários do rodízio personalizado">
                                        {editable ?
                                            <Select name="Usuários do rodízio" placeholder="Pesquisar..." options={getLeadRoundRobinUserOptions()} selected={newInbox?.leadRoundRobinUsers || []} multiple={true} onChange={(value) => handleChangeValue("leadRoundRobinUsers", value)} />
                                            :
                                            <span>{getOptionByOptionList(newInbox.leadRoundRobinUsers, users, "id", "value") || "-"}</span>
                                        }
                                    </FormGroup>
                                }
                            </>
                        }
                    </>
                }

                <BreakForm title="Boas-vindas" showAction={false} />
                <FormGroup labelText="Ativar">
                    {editable ? (
                        <Select
                            name="Selecione uma opção..."
                            placeholder="Pesquise uma opção"
                            options={optionsBoolean}
                            selected={+newInbox?.settings?.automations?.welcome?.enabled ?? ""}
                            onChange={(value) => handleAutomationChange("welcome.enabled", Boolean(+value))}
                        />
                    ) : (
                        <span>{newInbox?.settings?.automations?.welcome?.enabled ? "Sim" : "Não"}</span>
                    )}
                </FormGroup>
                {Boolean(+newInbox?.settings?.automations?.welcome?.enabled) && (
                    <FormGroup labelText="Mensagem">
                        {editable ? (
                            <Textarea
                                placeholder="Mensagem de boas vindas"
                                rows={3}
                                value={newInbox?.settings?.automations?.welcome?.message || ""}
                                onChange={(e) => handleAutomationChange("welcome.message", e.target.value)}
                            />
                        ) : (
                            <span>{newInbox?.settings?.automations?.welcome?.message || "-"}</span>
                        )}
                    </FormGroup>
                )}

                <BreakForm title="Mensagens por horário" iconAction={<HiPlus />} actionVariant="primary" handleAction={handleAddPeriod} showAction={editable && Boolean(+newInbox?.settings?.automations?.schedule?.enabled)} />
                <FormGroup labelText="Ativar">
                    {editable ? (
                        <Select
                            name="Selecione uma opção..."
                            placeholder="Pesquise uma opção"
                            options={optionsBoolean}
                            selected={+newInbox?.settings?.automations?.schedule?.enabled ?? ""}
                            onChange={(value) => handleAutomationChange("schedule.enabled", Boolean(+value))}
                        />
                    ) : (
                        <span>{newInbox?.settings?.automations?.schedule?.enabled ? "Sim" : "Não"}</span>
                    )}
                </FormGroup>
                {Boolean(+newInbox?.settings?.automations?.schedule?.enabled) && (
                    newInbox?.settings?.automations?.schedule?.periods?.map((period, index) => (
                        <div key={index}>
                            {index > 0 &&
                                <BreakForm iconAction={<MdOutlineDelete />} actionVariant="secondary" handleAction={() => handleRemovePeriod(index)} showAction={editable} />
                            }
                            <FormGroup>

                                <FormGroup labelText="Dias da semana">
                                    {editable ? (
                                        <Select
                                            name="Dias da semana"
                                            placeholder="Pesquise uma opção"
                                            options={weekDaysOptions}
                                            selected={period?.days || []}
                                            onChange={(value) => handleAutomationChange(`schedule.periods.${index}.days`, value)}
                                            multiple={true}
                                        />
                                    ) : (
                                        <span>{getOptionByOptionList(period?.days, weekDaysOptions, "id", "value") || "-"}</span>
                                    )}
                                </FormGroup>

                                <FormGroupInline>
                                    <FormGroup labelText="Início">
                                        {editable ? (
                                            <TimePicker
                                                name="Hora início"
                                                time={period.start}
                                                onChange={(value) => handleAutomationChange(`schedule.periods.${index}.start`, value)}
                                                disabled={!editable}
                                            />
                                        ) : (
                                            <span>{period.start || "-"}</span>
                                        )}
                                    </FormGroup>

                                    <FormGroup labelText="Fim">
                                        {editable ? (
                                            <TimePicker
                                                name="Hora fim"
                                                time={period.end}
                                                onChange={(value) => handleAutomationChange(`schedule.periods.${index}.end`, value)}
                                                disabled={!editable}
                                            />
                                        ) : (
                                            <span>{period.end || "-"}</span>
                                        )}
                                    </FormGroup>
                                </FormGroupInline>

                                <FormGroup labelText="Mensagem">
                                    {editable ? (
                                        <Textarea
                                            placeholder="Mensagem enviada neste período"
                                            rows={3}
                                            value={period.message}
                                            onChange={(e) => handleAutomationChange(`schedule.periods.${index}.message`, e.target.value)}
                                        />
                                    ) : (
                                        <span>{period.message || "-"}</span>
                                    )}
                                </FormGroup>

                                <FormGroup labelText="Intervalo mínimo (minutos)">
                                    {editable ? (
                                        <Input
                                            type="number"
                                            placeholder="Ex: 30"
                                            value={period.cooldown_minutes || 0}
                                            onChange={(e) =>
                                                handleAutomationChange(
                                                    `schedule.periods.${index}.cooldown_minutes`,
                                                    Number(e.target.value)
                                                )
                                            }
                                        />
                                    ) : (
                                        <span>{period.cooldown_minutes || "-"}</span>
                                    )}
                                </FormGroup>
                            </FormGroup>
                        </div>
                    ))
                )}

                {/* <BreakForm title="Inatividade" showAction={false} />
                <FormGroup labelText="Ativar">
                    {editable ? (
                        <Select
                            name="Selecione uma opção..."
                            placeholder="Pesquise uma opção"
                            options={optionsBoolean}
                            selected={+newInbox?.settings?.automations?.inactive_open?.enabled ?? ""}
                            onChange={(value) => handleAutomationChange("inactive_open.enabled", Boolean(+value))}
                        />
                    ) : (
                        <span>{newInbox?.settings?.automations?.inactive_open?.enabled ? "Sim" : "Não"}</span>
                    )}
                </FormGroup>
                {Boolean(+newInbox?.settings?.automations?.inactive_open?.enabled) && (
                    <>
                        <FormGroup labelText="Tempo (minutos)">
                            {editable ? (
                                <Input
                                    type="number"
                                    value={newInbox?.settings?.automations?.inactive_open?.delay_minutes || 0}
                                    onChange={(e) => handleAutomationChange("inactive_open.delay_minutes", Number(e.target.value))}
                                />
                            ) : (
                                <span>{newInbox?.settings?.automations?.inactive_open?.delay_minutes || "-"}</span>
                            )}
                        </FormGroup>
                        <FormGroup labelText="Mensagem">
                            {editable ? (
                                <Textarea
                                    placeholder="Mensagem de inatividade"
                                    rows={3}
                                    value={newInbox?.settings?.automations?.inactive_open?.message || ""}
                                    onChange={(e) => handleAutomationChange("inactive_open.message", e.target.value)}
                                />
                            ) : (
                                <span>{newInbox?.settings?.automations?.inactive_open?.message || "-"}</span>
                            )}
                        </FormGroup>
                    </>
                )} */}

                <BreakForm title="Reabertura de conversa" showAction={false} />
                <FormGroup labelText="Ativar">
                    {editable ? (
                        <Select
                            name="Selecione uma opção..."
                            placeholder="Pesquise uma opção"
                            options={optionsBoolean}
                            selected={+newInbox?.settings?.automations?.reopen?.enabled ?? ""}
                            onChange={(value) => handleAutomationChange("reopen.enabled", Boolean(+value))}
                        />
                    ) : (
                        <span>{newInbox?.settings?.automations?.reopen?.enabled ? "Sim" : "Não"}</span>
                    )}
                </FormGroup>
                {Boolean(+newInbox?.settings?.automations?.reopen?.enabled) && (
                    <FormGroup labelText="Mensagem">
                        {editable ? (
                            <Textarea
                                placeholder="Mensagem de reabertura"
                                rows={3}
                                value={newInbox?.settings?.automations?.reopen?.message || ""}
                                onChange={(e) => handleAutomationChange("reopen.message", e.target.value)}
                            />
                        ) : (
                            <span>{newInbox?.settings?.automations?.reopen?.message || "-"}</span>
                        )}
                    </FormGroup>
                )}

                <BreakForm title="Áudios" showAction={false} />
                <FormGroup labelText="Transcrever áudios">
                    {editable ?
                        <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={optionsBoolean || []} selected={+newInbox?.transcribe_audio ?? '0'} onChange={(value) => handleChangeValue("transcribe_audio", value)} multiple={false} />
                        :
                        <span>{getPropertyForItemInArrayById(+newInbox.transcribe_audio, optionsBoolean, "id", "value") || "-"}</span>
                    }
                </FormGroup>

                <BreakForm title="Assinatura" showAction={false} />
                <FormGroup labelText="Incluir assinatura">
                    {editable ?
                        <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={optionsBoolean || []} selected={+newInbox?.add_signature ?? ""} onChange={(value) => handleChangeValue("add_signature", value)} multiple={false} />
                        :
                        <span>{getPropertyForItemInArrayById(+newInbox.add_signature, optionsBoolean, "id", "value") || "-"}</span>
                    }
                </FormGroup>
                {Boolean(+newInbox.add_signature) && (
                    <FormGroup labelText="Tipo">
                        {editable ?
                            <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={signOptions || []} selected={newInbox?.type_signature || ""} onChange={(value) => handleChangeValue("type_signature", value)} multiple={false} />
                            :
                            <span>{getPropertyForItemInArrayById(newInbox.type_signature, signOptions, "id", "value") || "-"}</span>
                        }
                    </FormGroup>
                )}

                {editable &&
                    <FormGroupInline>
                        <Button variant='primary' onClick={handleSave}>Salvar</Button>
                        <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                    </FormGroupInline>
                }
            </form>
        </Modal>
    )
}

export default ModalInbox
